const Contrast = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00065 13.3335C10.9462 13.3335 13.334 10.9457 13.334 8.00016C13.334 5.05464 10.9462 2.66683 8.00065 2.66683V13.3335ZM14.6673 8.00016C14.6673 11.6821 11.6825 14.6668 8.00065 14.6668C7.75079 14.6668 7.5039 14.6531 7.26073 14.6262C3.92673 14.2576 1.33398 11.4321 1.33398 8.00016C1.33398 4.56819 3.92673 1.74271 7.26073 1.37415C7.5039 1.34727 7.75079 1.3335 8.00065 1.3335C11.6825 1.3335 14.6673 4.31826 14.6673 8.00016Z"
      fill="#7A7A83"
    />
  </svg>
)

export default Contrast
